export default __webpack_public_path__ + "static/media/sd-pop-1.28b2758b.jpg";